import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisableOfflineDirective } from './disable-offline.directive';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { OfflineBannerComponent } from './offline-banner/offline-banner.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, MatSnackBarModule, DisableOfflineDirective, OfflineBannerComponent],
  exports: [DisableOfflineDirective, OfflineBannerComponent],
})
export class AngularPwaModule {}
